import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class Mentionables {
  constructor() {
    _defineProperty(this, "formats", []);
    _defineProperty(this, "mentionables", {});
  }
  /**
   * Register a new mention format.
   * Must extend MentionFormat and have a unique unused trigger symbol.
   */
  format(format) {
    this.formats.push(format);
    return this;
  }

  /**
   * Register a new mentionable model to a mention format.
   * Only works if the format has already been registered,
   *  and the format allows using multiple mentionables.
   *
   * @param symbol The trigger symbol of the format to extend (ex: @).
   * @param mentionable The mentionable instance to register.
   *                    Must extend MentionableModel.
   */
  mentionable(symbol, mentionable) {
    if (!this.mentionables[symbol]) {
      this.mentionables[symbol] = [];
    }
    this.mentionables[symbol].push(mentionable);
    return this;
  }
  extend(app) {
    for (const format of this.formats) {
      app.mentionFormats.extend(format);
    }
    for (const symbol in this.mentionables) {
      const format = app.mentionFormats.get(symbol);
      if (!format) continue;
      for (const mentionable of this.mentionables[symbol]) {
        format.extend(mentionable);
      }
    }
  }
}
flarum.reg.add('flarum-mentions', 'forum/extenders/Mentionables', Mentionables);